<div class="flex flex-col my-[5px]">
  @if (isNew && !editing) {
    <div class="flex justify-end">
      <button
        type="button"
        matMiniFab
        class="h-full w-[30px] text-[20px] leading-[30px] mb-2 blue-theme-bg-1 mt-1 round-btn"
        name="commentsComponentAddBtn"
        (click)="beginEdit()"
        [disabled]="disable"
        color="primary"
      >
        <mat-icon color="primary" class="text-white">add</mat-icon>
      </button>
    </div>
  }

  @if (!isNew || editing) {
    <div class="pb-4 border-b border-dashed border-[#aaa]">
      @if (!editing) {
        <div>
          <span>{{ comment.get('comment')?.value }}</span>
        </div>
        <div>
          <div class="float-right text-[11px]">
            <strong name="commentsComponentName">
              {{ comment.get('name')?.value }}
            </strong>
            @if (comment.get('timestamp')?.value) {
              <span name="commentsComponentDate" class="mr-[5px]">
                &nbsp;on
                {{
                  formatDate(comment.get('timestamp')?.value) | date: 'medium'
                }}
              </span>
            }
            @if (sameUser) {
              <mat-icon
                onkeydown="null"
                class="text-[#3f51b5] text-[18px] h-[18px] w-[18px] cursor-pointer material-icons-outlined"
                name="commentsComponentEdit"
                title="Edit"
                (click)="beginEdit()"
              >
                edit
              </mat-icon>
            }
            @if (sameUser) {
              <mat-icon
                onkeydown="null"
                class="text-red-500 text-[18px] h-[18px] w-[18px] cursor-pointer material-icons-outlined"
                name="commentsComponentDelete"
                title="Delete"
                (click)="deleteComment()"
              >
                delete
              </mat-icon>
            }
          </div>
        </div>
      } @else {
        <textarea
          class="border-2 border-[#3f51b5] text-[14px] h-[4em] w-full resize-none outline-none mb-2 theme-bg-3"
          name="commentsComponentEditArea"
          appAutofocus
          [formControl]="entry"
          (keyup)="onKeyUp($event)"
          (keydown)="onKeyDown($event)"
        ></textarea>
        <mat-hint align="start">
          press escape to
          <strong
            (keyup)="(null)"
            (click)="cancelEdit()"
            class="text-primary cursor-pointer text-red-500"
          >
            cancel
          </strong>
          enter to
          <strong
            (keyup)="(null)"
            (click)="addComment()"
            class="text-secondary cursor-pointer text-blue-500"
          >
            save
          </strong>
        </mat-hint>
      }
    </div>
  }
</div>
